import React, { useEffect } from "react";

interface SuccessModalProps {
  onClose: () => void;
}

export const SuccessModal: React.FC<SuccessModalProps> = ({ onClose }) => {
  useEffect(() => {
    const timer = setTimeout(onClose, 3000);
    return () => clearTimeout(timer);
  }, [onClose]);

  return (
    <div className="fixed inset-0 bg-black/50 z-50 flex justify-center items-center">
      <div className="bg-white dark:bg-[#1a1a1a] rounded-lg p-6 w-full max-w-xs text-center">
        <h2 className="text-lg font-bold mb-2">✅ Withdrawal request successfully sent to Administrator</h2>
      </div>
    </div>
  );
};
